import { Box, Container, Typography } from "@mui/material";
import { useLanguage } from "../../i18n/LanguageContext";

const listClasses = ["one", "two", "three", "four", "five", "six"];

const content = {
    en: {
        title: "Professional Services",
        intro: "TARQIA offers a wide range of professional services to help businesses succeed in today’s fast-paced and constantly evolving digital landscape. Here are some of the core services that TARQIA provides:",
        items: [
            "Change Management and Enterprise Development - TARQIA helps companies manage change and develop their enterprises through effective strategies, processes, and tools.",
            "Software Development - TARQIA has a team of skilled software developers who can design and develop custom software solutions that meet the unique needs of their clients.",
            "Project Management Experts - TARQIA’s project management experts can help businesses manage their projects from start to finish, ensuring that they are completed on time, within budget, and to the highest standards of quality.",
            "Business and technical transformation - TARQIA helps businesses transform their digital and technical capabilities, helping them adapt to the constantly evolving landscape of the digital world.",
            "System Integration - TARQIA helps businesses integrate their systems and technologies, ensuring that they work together seamlessly to achieve their business objectives.",
            "Overall, TARQIA’s wide range of professional services is designed to help businesses succeed in today’s digital landscape, by providing them with the expertise, tools, and strategies they need to thrive.",
        ],
    },
    ar: {
        title: "الخدمات المهنية",
        intro: "تقدم ترقية مجموعة واسعة من الخدمات المهنية لمساعدة الشركات على النجاح في بيئة رقمية سريعة ومتغيرة باستمرار. وفيما يلي أبرز الخدمات التي تقدمها ترقية:",
        items: [
            "إدارة التغيير وتطوير المؤسسات - تساعد ترقية الشركات على إدارة التغيير وتطوير مؤسساتها من خلال استراتيجيات وعمليات وأدوات فعّالة.",
            "تطوير البرمجيات - يضم فريق ترقية مطورين متمرسين يصممون ويطورون حلولاً برمجية مخصصة تلبي الاحتياجات الفريدة لكل عميل.",
            "خبراء إدارة المشاريع - يساعد خبراء إدارة المشاريع في ترقية الشركات على إدارة مشاريعها من البداية حتى النهاية، وضمان إنجازها في الوقت المحدد وضمن الميزانية وبأعلى معايير الجودة.",
            "التحول التقني والتجاري - تساعد ترقية الشركات على تطوير قدراتها الرقمية والتقنية لمواكبة المشهد الرقمي المتغير باستمرار.",
            "تكامل الأنظمة - تساعد ترقية الشركات على ربط أنظمتها وتقنياتها لتعمل معاً بسلاسة وتحقق أهدافها.",
            "باختصار، صُممت خدمات ترقية المهنية المتنوعة لمساعدة الشركات على النجاح في العالم الرقمي، من خلال تزويدها بالخبرات والأدوات والاستراتيجيات التي تحتاجها للنمو والازدهار.",
        ],
    },
};

const Services = () => {
    const { lang } = useLanguage();
    const c = content[lang];
    return (
        <>
            <Container maxWidth="lg" align="center" className="eParkingSection" id="servicesSection">
                <Typography variant="h3" gutterBottom >
                    {c.title}
                </Typography>
                <Box className="EParkingContent">
                    <Typography variant="subtitle1" gutterBottom >
                        {c.intro}
                    </Typography>
                    <Box className="eParkingList">
                        {c.items.map((item, index) => (
                            <Box className="listContainer" key={index}>
                                <Typography variant="subtitle1" className={listClasses[index]} >
                                    {item}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Container>
        </>
    )
}
export default Services;
